export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - ABÓBORA MANTEIGA-BUTTERNUT.507e5d7a.pdf";